import api from './client';

export const getPersonalFolders  = ()          => api.get('/personal-files/folders').then(r => r.data);
export const createPersonalFolder = (name)     => api.post('/personal-files/folders', { name }).then(r => r.data);
export const renamePersonalFolder = (id, name) => api.put(`/personal-files/folders/${id}`, { name }).then(r => r.data);
export const deletePersonalFolder = (id)       => api.delete(`/personal-files/folders/${id}`).then(r => r.data);

export const getPersonalFiles   = (folderId)   => api.get('/personal-files', { params: { folderId } }).then(r => r.data);
export const uploadPersonalFiles = (folderId, fileList) => {
  const fd = new FormData();
  fd.append('folderId', folderId);
  Array.from(fileList).forEach(f => fd.append('files', f));
  return api.post('/personal-files/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const deletePersonalFile  = (id)        => api.delete(`/personal-files/${id}`).then(r => r.data);
